import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { authenticatedFetch } from "@/services/utils/authenticatedFetch";
import { BlobStore } from "@/stores/BlobStore";
import { TBlobsResponse } from "@/types/TBlobsResponse";

export function useBlobData() {
  const setBlobs = BlobStore(state => state.setBlobs);
  const setLoading = BlobStore(state => state.setLoading);
  const setError = BlobStore(state => state.setError);

  const query = useQuery({
    queryKey: ["blobs"],
    queryFn: async (): Promise<TBlobsResponse> => {
      const url = "/api/blobs";
      const response = await authenticatedFetch(url);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch blobs: ${response.status}`);
      }
      
      return response.json();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  // Sync TanStack Query state with BlobStore
  useEffect(() => {
    setLoading(query.isLoading);
    
    if (query.error) {
      setError(query.error instanceof Error ? query.error.message : "An error occurred");
    } else {
      setError(null);
    }
    
    if (query.data?.status === "OK" && query.data.response) {
      setBlobs(query.data.response);
    }
  }, [query.data, query.error, query.isLoading, setBlobs, setError, setLoading]);

  return query;
}

